import { Column } from 'react-table'
import { WareHouseSearchOptions } from 'shared/models/Enum'
import { IProductDimension } from 'shared/models/IProductDimension'

const Columns: Column<IProductDimension>[] = [
  {
    Header: 'Productgroepcode',
    accessor: 'productGroupCode',
    filter: (rows, columnIds, filterValue: string) => {
      if (!filterValue || filterValue.trim() === '') {
        return rows
      }
      return rows.filter(({ values }) => {
        const value = values[columnIds[0]]
        if (value == null) return false
        return value
          .toString()
          .toLowerCase()
          .startsWith(filterValue.toLowerCase().trim())
      })
    },
  },
  {
    Header: 'Fustcode',
    accessor: 'fustCode',
    Cell: ({ value }: { value: number | null | undefined }) => (
      <>{value || '*'}</>
    ),
    filter: (rows, columnIds, filterValue: string) => {
      if (!filterValue || filterValue.trim() === '') {
        return rows
      }
      return rows.filter(({ values }) => {
        const value = values[columnIds[0]]
        if (value == null) return false
        return value
          .toString()
          .toLowerCase()
          .startsWith(filterValue.toLowerCase().trim())
      })
    },
  },
  {
    Header: 'Vestiging',
    accessor: 'warehouseId',
    Cell: ({ value }: { value: number }) => (
      <>{WareHouseSearchOptions[value]}</>
    ),
    filter: (rows, columnIds, filterValue: string | number) => {
      if (filterValue === '' || filterValue == null) {
        return rows
      }
      const numValue = Number(filterValue)
      if (isNaN(numValue) || numValue === -1) return rows
      return rows.filter(({ values }) => {
        return values[columnIds[0]] === numValue
      })
    },
  },
  {
    Header: 'Diepte in mm',
    accessor: 'depthInMM',
    Cell: ({ value }: { value: number | null | undefined }) => (
      <>{value || '-'}</>
    ),
  },
  {
    Header: 'Breedte in mm',
    accessor: 'widthInMM',
    Cell: ({ value }: { value: number | null | undefined }) => (
      <>{value || '-'}</>
    ),
  },
  {
    Header: 'Hoogte in mm',
    accessor: 'heightInMM',
    Cell: ({ value }: { value: number | null | undefined }) => (
      <>{value || '-'}</>
    ),
  },
  {
    Header: 'Diepte + %',
    accessor: 'depthInPercentage',
    Cell: ({ value }: { value: number | null | undefined }) => (
      <>{value ? `+${value}%` : '-'}</>
    ),
  },
  {
    Header: 'Breedte + %',
    accessor: 'widthInPercentage',
    Cell: ({ value }: { value: number | null | undefined }) => (
      <>{value ? `+${value}%` : '-'}</>
    ),
  },
  {
    Header: 'Hoogte + %',
    accessor: 'heightInPercentage',
    Cell: ({ value }: { value: number | null | undefined }) => (
      <>{value ? `+${value}%` : '-'}</>
    ),
  },
]

export default Columns
